import * as ReactBootstrap from "react-bootstrap";
import React from "react";

export const DPD = ({questionId, answers, onAnswer}) => {
    return (
        <>
            <ReactBootstrap.Form.Group key={questionId} controlId={questionId}>
                <ReactBootstrap.Form.Control
                    onChange={(e) => onAnswer(e.target.value)}
                    as="select"
                >
                    <option key={`${questionId}-select-one`} value="----------------">
                        -------Select One---------
                    </option>
                    {answers.map((a) => {
                        return (
                            <option
                                key={`${questionId}-${a.answerId}-select-one`}
                                value={a.answerId}
                            >
                                {a.answerPhrase}{' '}
                            </option>
                        )
                    })}
                </ReactBootstrap.Form.Control>
            </ReactBootstrap.Form.Group>
        </>
    )
}
